import Hero from '@/components/Hero';
import Marquee from '@/components/Marquee';
import StatsBand from '@/components/StatsBand';
import HowItWorks from '@/components/HowItWorks';
import VehicleFleet from '@/components/VehicleFleet';
import IraqMap from '@/components/IraqMap';
import DashboardPreview from '@/components/DashboardPreview';
import BentoGrid from '@/components/BentoGrid';
import AppsPlatforms from '@/components/AppsPlatforms';
import CTABand from '@/components/CTABand';
import SectionHeading from '@/components/SectionHeading';
import { Reveal } from '@/components/Reveal';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';

export default function Home() {
  const { lang, t } = useLanguage();
  const show = (k) => t(`home.${k}`) !== false;

  return (
    <div key={lang}>
      <Hero />
      {show('showMarquee') && <Marquee />}
      {show('showStats') && <StatsBand />}
      {show('showHow') && <HowItWorks />}
      {show('showVehicles') && <VehicleFleet />}
      {show('showBento') && <BentoGrid />}

      {show('showCoverage') && <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8" data-testid="coverage-section">
        <Reveal>
          <IraqMap />
        </Reveal>
      </section>}

      {show('showDashboard') && <section id="dashboard-section" className="border-y border-brand-line bg-brand-alt/50 py-20" data-testid="dashboard-section">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <SectionHeading eyebrow="dashboard.eyebrow" title="dashboard.title" sub="dashboard.sub" align="center" />
          <div className="mt-14">
            <DashboardPreview />
          </div>
          <div className="mt-10 text-center">
            <Link to={t('dashboard.openLink')} data-testid="dashboard-open-btn" className="inline-flex items-center rounded-full bg-brand-blue px-7 py-3.5 text-sm font-bold text-white transition-all duration-300 hover:bg-brand-blueHover">{t('dashboard.openBtn')}</Link>
          </div>
        </div>
      </section>}

      {show('showApps') && <AppsPlatforms />}

      {show('showCta') && <CTABand />}
    </div>
  );
}
